import { css } from '@emotion/react';
import t from 'react-translate';
import LoadingSpinner, { LoadingSpinnerType } from 'shared/components/loading-spinner';
import { genAIGradientType4, gray3, hexToRgbaString, lowTide } from 'styles/global_defaults/colors';
import {
  doubleSpacing,
  quarterSpacing,
  standardSpacing,
} from 'styles/global_defaults/scaffolding';
import {
  ReactComponent as AIPersona,
} from 'styles/icons/ai-persona.svg';

type AiChatProps = {
  content?: string;
  isStreaming?: boolean;
};

const loadingDotStyles = css`
  .spinner {
    display: flex !important;
    gap: ${quarterSpacing}px !important;
    width: fit-content !important;
  }
  .spinner > div {
    width: 8px !important;
    height: 8px !important;
    background-color: ${gray3} !important;
  }
`;

const AiChat = (props: AiChatProps) => {
  const { content, isStreaming = false } = props;
  const styles = css`
  .ai-profile {
    width: ${doubleSpacing}px;
    height: ${doubleSpacing}px;
  }
  .ai-chat-bubble {
    border-radius: ${standardSpacing}px;
    background: ${isStreaming ? `${hexToRgbaString(lowTide, 0.15)}` : `linear-gradient(white, white) padding-box,
      ${genAIGradientType4} border-box`};
    border: 1px solid transparent;
    min-height: 45px;
    max-width: 75%;
  }
`;


  return (
    <div css={styles} className='d-flex left-0'>
      <div className='ai-profile'>
        <AIPersona
          width={doubleSpacing}
          height={doubleSpacing}
          role='img'
          aria-label={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.AI_CHARACTER_AVATAR()}
        />
      </div>
      <div className='ai-chat-bubble ml-2 py-2 px-4 d-flex align-items-center'>
        {
          isStreaming ? (
            <LoadingSpinner
              type={LoadingSpinnerType.DOTS}
              styles={loadingDotStyles}
            />
          ) : <p className='mb-0'>{content}</p>
        }
      </div>
    </div>
  );
};

export default AiChat;
